import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/"); return; }
      const session_id = m[1];
      try {
        const ref = (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("fliboe_ref") : null) || undefined;
        const { data } = await api.post("/auth/session", { session_id, ref });
        try { sessionStorage.removeItem("fliboe_ref"); } catch (_) {}
        // Also store token for Authorization header fallback (mobile Safari cookie issues)
        if (data?.session_token) localStorage.setItem("fliboe_token", data.session_token);
        setUser(data.user);
        // strip hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: data.user }, replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="max-w-md mx-auto py-32 text-center text-slate-500 fl-mono text-xs uppercase tracking-widest">
      // Tuning your frequency…
    </div>
  );
}
